const fetchTtl = async (token) => {
  const url = '/api/auth/sessions/ttl';
  const headers = new Headers({
    Accept: `application/vnd.qpp.cms.gov.v2+json`,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });
  const fetchOptions = { headers };
  try {
    const response = await fetch(url, fetchOptions);
    const json = await response.json();
    if (response.ok) {
      return json.data.time_remaining;
    }
    return 0;
  } catch {
    return 0;
  }
};

export default fetchTtl;
